import {
  defaultNewContact,
  defaultNewVehicle,
  defaultSelectedDocument,
  defaultSelectedDocumentProduct
} from "./state";
import {fetchInterestProducts} from "../prospective-client/actions";
import {NIT_COLSAISA} from "../../util/subscribersConstanst";

/**
 * Extrae la ubicación (inventories.location) desde el product.inventory embebido
 * en un document_product. Devuelve null si no hay inventario disponible.
 * @param dp document_product
 * @returns {string|null}
 */
function extractLocationFromProduct(dp) {
  if (!dp || !dp.product || !dp.product.inventory) {
    return null;
  }

  let inventory = Array.isArray(dp.product.inventory)
    ? dp.product.inventory[0]
    : dp.product.inventory;

  return inventory ? inventory.location : null;
}

/**
 * Asigna un valor a la variable de state error
 * @param state
 * @param error
 */
export function setError(state, error) {
  state.error = error;
}

/**
 * Asigna un valor a la variable de state action
 * @param state
 * @param action
 */
export function setAction(state, action) {
  state.action = action;
}

export function setTypeGuides(state, data) {
  state.typeGuides = data;
}

export function setTypeImmpression(state, typeImpresions) {
  state.typeImpresions = typeImpresions;
}

export function setdocumentsProductsImport(state , documents_products_import){
  state.documents_products_import = documents_products_import.documents_product_import
}

export function applied_expenses(state, applied_expenses){
  state.applied_expenses = applied_expenses
}

export function setexpenses(state , expenses){
  state.expenses = expenses.expenses
}
/**
 * Asigna valores por defecto a branchoffice_id y branchoffice_warehouse_id de selected_document
 * Los valores por defecto son los que se encuentran en el localStorage
 * @param state
 */
export function setDefaultBranchOfficeAndBranchOfficeWarehouse(state) {
  let branchoffice_id = localStorage.getItem("selected_branchoffice");
  let branchoffice_warehouse_id = localStorage.getItem(
    "selected_branchoffice_warehouse"
  );

  state.selected_document.branchoffice_id = Number(branchoffice_id);
  state.selected_document.branchoffice_warehouse_id = Number(
    branchoffice_warehouse_id
  );
}

/**
 * Asigna un valor a la variable de state selected_model
 * @param state
 * @param selected_model
 */
export function setSelectedModel(state, selected_model) {
  state.selected_model = selected_model;

}

/**
 *
 * @param state
 * @param data
 */
export function setModels(state, data) {
  state.models = data;
}

export function setSelected_model_list_document(state, selected_model_list_document){
  state.selected_model_list_document = selected_model_list_document
}

export function setTableSearchGlobalcolumns(state, ColumnsParams) {

    let subscriber = JSON.parse(localStorage.getItem('subscriber'));
    let manager_wms = false;
    let document_nature = ColumnsParams.voucher_type && ColumnsParams.voucher_type.document_nature ? ColumnsParams.voucher_type.document_nature.code_parameter : '';

    if (subscriber && subscriber != undefined) {
        manager_wms = subscriber.manager_wms;
    }

    let visible_columns = {
        import_number: state.selected_model_list_document ? state.selected_model_list_document.import_number && state.selected_model_list_document.import_number != '2' : false,
        project: state.selected_model_list_document ? state.selected_model_list_document.select_projects && state.selected_model_list_document.select_projects != '2' : false,
        seller: state.selected_model_list_document ? state.selected_model_list_document.see_seller && state.selected_model_list_document.see_seller != '2' : false,
        email_status: subscriber.serv_fact_elect == 'u2_software' && ColumnsParams.voucher_type && ColumnsParams.voucher_type.electronic_bill && !(state.selected_model_list_document && state.selected_model_list_document.code === '666'),
        erp:subscriber.identification == "900338016",
        license_plate: state.selected_model_list_document ? state.selected_model_list_document.manage_vehicle : false,
        fac:['10'].includes(document_nature),
        order_status: document_nature === '11'
      };

    
    let consecutive_doc_title = 'Número'
    if (['10'].includes(document_nature)) consecutive_doc_title = 'Comprobante';

    state.TableSearchGlobal.columns = [
        {
            label: 'Fecha',
            key: 'document_date',
            tdClass: 'text-nowrap'
        },
        !state.TableSearchGlobal.params.branchoffice_id ? { label: 'Sede', key: 'branchoffice.name'} : {},
        {
            label: 'Tipo Documento',
            key: 'vouchertype.name_voucher_type'
        },
        {
            label: consecutive_doc_title,
            key: 'consecutive',
            sortable: true
        },
        visible_columns.fac ? {label: 'Documento Cruce', key: 'fac_cruce'} : {},
        {
            label: 'Tercero',
            key: 'contact'
        },
        visible_columns.license_plate ? {
            label: 'Placa',
            key: 'contact_vehicle.license_plate'
        } : {},
        visible_columns.import_number ? {label: 'Num-Import', key: 'import_number'} : {},
        visible_columns.project ? {label: 'Proyecto', key: 'project'} : {},
        visible_columns.seller ? {label: 'Vendedor', key: 'seller.name'} : {},
        {
            label: 'Valor Total',
            key: 'total_value'
        },
        visible_columns.email_status ? {label: 'Eventos Radian', key: 'events_radian'} : {},
        visible_columns.email_status ? { label: 'Estado Correo', key: 'email_status'} : {},
        visible_columns.erp ? {label: 'Erp', key: 'erp'} : {},
        manager_wms ? {label: 'Estado WMS', key: 'error_wms',} : {},
        visible_columns.order_status ? {label: 'Estado', key: 'order_status'} : {},
        {
            label: 'Acciones',
            key: 'actions'
        }
    ];
}

/**
 *
 * @param state
 * @param data
 */
export function setSearchDocumentGlobal(state, data) {
  // Agregamos los datos de la tabla
  state.TableSearchGlobal.data = data.data;

  // Quitamos los valores de la tabla del arreglo
  delete data.data;

  // Agregamos los datos de la paginacion
  state.TableSearchGlobal.pagination = data;
}

/**
 * Restablece el valor por defecto de la variable de state selected_document
 */
export function resetSelectedDocument(state) {
  state.selected_document = defaultSelectedDocument();
}

/**
 * Asigna un valor a la variable de state fetch_data
 * @param state
 * @param fetch_data
 */
export function setFetchData(state, fetch_data) {
  state.fetch_data = fetch_data;
}

/**
 * Asigna un valor al atributo type de la variable de state params_contacts
 * @param state
 * @param selected_model
 */
export function setTypeContact(state, selected_model) {
  let contact_type = selected_model.contact_type;

  let type = "is_customer";

  switch (contact_type) {
    case 1:
      type = "is_customer";
      break;
    case 2:
      type = "is_provider";
      break;
    case 3:
      type = "is_employee";
      break;
  }

  state.params_contacts.type = type;
}

export function setTypeContactAditional(state, type_aditional) {
  let contact_type = type_aditional;

  let type = "is_customer";

  switch (contact_type) {
    case 1:
      type = "is_customer";
      break;
    case 2:
      type = "is_provider";
      break;
    case 3:
      type = "is_employee";
      break;
  }

  state.params_contacts.type = type;
}

/**
 * Asigna un valor al atributo vouchertype_id de la variable de state selected_document
 * @param state
 * @param selected_model
 */
export function setVoucherTypeToSelectedDocument(state, selected_model) {
  let voucherType_id = selected_model.voucherType_id;

  state.selected_document.vouchertype_id = voucherType_id;
}

export function setFilenameSelectedDocument(state, selected_document) {
  state.selected_document.filename = selected_document.filename;
}

/**
 * Asigna un valor a la variable de state selected_document
 * @param state
 * @param branchoffices
 */
export function setSelectedDocument(state, selected_document) {
  //productos con promo
  selected_document.documents_products.map((dp, indexdp) => {
    if (dp.promotion) {
      dp.applied_promotion = dp.promotion.description;
    }

    // Siempre debe quedar como propiedad propia del objeto (aunque sea null),
    // porque grid.vue solo escribe valores editados sobre propiedades ya existentes.
    dp.location = extractLocationFromProduct(dp);

    // if (dp.is_benefit) {
    //   dp.unit_value_before_taxes = 0;
    // }
  });

  state.selected_document = selected_document;
  if (state.selected_document){
    state.selected_document.internal_observations = state.selected_document.internal_observations
    state.selected_document.internal_observations_user = state.selected_document.internal_observations_user || null
  }
}

export function setSelectedDocumentInternalObservationsUser(state, user) {
  if (state.selected_document) {
    state.selected_document.internal_observations_user = user || null
  }
}

/**
 * Establecer un valor para el atributo internal_observations de la variable selected_document.
 */
export function resetInternalObservationsToSelectedDocument(state) {
  state.selected_document.internal_observations = null;
  state.selected_document.internal_observations_user = null;
}

export function setDocumentVehicle(state, data) {
  if (data.document_vehicle) {
    state.document_vehicle = data.document_vehicle;  
  }

  if (data.document_vehicle_inspection && data.document_vehicle_inspection.length > 0) {
    state.document_vehicle_inspection = data.document_vehicle_inspection;  
  }
}

/**
 * Corregimos las existencias
 *
 * @param state
 * @param branchoffices
 */
export function setStockDocumentProducts(state, document_products) {
  document_products.map((dp, index) => {
    let key_p = state.selected_document.documents_products.findIndex(
      sdp => sdp.id == dp.document_product_id
    );

    if (key_p >= 0) {
      state.selected_document.documents_products[
        key_p
      ].product.inventory[0].stock = dp.stock;
      state.selected_document.documents_products[key_p].quantity = dp.stock;
    }
  });
}

/**
 * Asigna un valor a la variable de state backup_documents_products
 * @param state
 * @param branchoffices
 */
export function setBackupDocumentsProducts(state) {
  state.backup_documents_products = JSON.parse(
    JSON.stringify(state.selected_document.documents_products)
  );
}

/**
 * Restaura un valor a la variable de state documents_products
 * @param state
 * @param branchoffices
 */
export function restoreDocumentsProductsFromBackup(state) {
  state.selected_document.documents_products.map(dp => {
    state.backup_documents_products.map(bdp => {
      if (dp.product_id == bdp.product_id) {
        dp.quantity = bdp.quantity;
      }
    });
  });
}

/**
 * Asigna un valor a la variable de state documents_for_back_order que sirve para calcular el back_order
 * @param state
 * @param branchoffices
 */
export function setDocumentsForBackOrder(state, documents_for_back_order) {
  state.documents_for_back_order = documents_for_back_order;
}

/**
 * Asigna un valor por defecto a la variable de state selected_document_product
 * @param state
 * @param branchoffices
 */
export function setDefaultSelectedDocumentProduct(state) {
  state.selected_document_product = defaultSelectedDocumentProduct();
}

/**
 * Asigna un valor a la variable de state selected_document_product
 * @param state
 * @param branchoffices
 */
export function setSelectedDocumentProduct(state, selected_document_product) {
  state.selected_document_product = selected_document_product;
}

/**
 * Asigna un valor a la variable de state branchoffices
 * @param state
 * @param branchoffices
 */
export function setBranchOffices(state, branchoffices) {
  state.branchoffices = branchoffices.map(b => {
    return { value: b.id, label: b.name };
  });
}

/**
 * Asigna un valor a la variable de state branchoffices_warehouses
 * @param state
 * @param branchoffices_warehouses
 */
export function setBranchOfficesWarehouses(state, branchoffices_warehouses) {
    let subscriber = JSON.parse(localStorage.getItem('subscriber'));
    let is_colsaisa = subscriber.identification === NIT_COLSAISA;
    state.branchoffices_warehouses = branchoffices_warehouses.map(bw => {
    let label_warehouse = is_colsaisa ? (bw.branchoffice && bw.branchoffice.name ? bw.branchoffice.name + '-' + bw.warehouse_description : bw.warehouse_description) : bw.warehouse_description;

    return { value: bw.id, label: label_warehouse };
  });
}

/**
 * Asigna un valor a la variable de state contacts
 * @param state
 * @param contacts
 */
export function setContacts(state, contacts) {
  state.contacts = contacts;
}

export function setContactsLite(state, contacts_lite) {
  state.contacts_lite = contacts_lite;
}

export function setContactsAditional(state, contacts) {
  state.contacts_aditional = contacts;
}

/**
 * Asigna un valor a la variable de state contacts_warehouses
 * @param state
 * @param contacts
 */
export function setContactsWarehouses(state, contacts_warehouses) {
  state.contacts_warehouses = contacts_warehouses;
}

/**
 * Asigna un valor al atributo filter de params_contacts
 * @param state
 * @param filter
 */
export function setParamsContacts(state, filter) {
  state.params_contacts.filter = filter;
}

/**
 * Asigna valores a los datos del tercero en selected_document
 * @param state
 * @param contact_id
 */
export function setDataContact(state, contact_id) {
  let contact = state.contacts.find(c => c.id == contact_id);
  if (contact) {
    state.selected_document.contact = contact;
    state.selected_document.address = contact.address;
    state.selected_document.telephone = contact.main_telephone;
    state.selected_document.city = contact.city.city;

    // compras
    if (state.selected_model.voucher_type && state.selected_model.voucher_type.document_nature && state.selected_model.voucher_type.document_nature.code_parameter === '10') {
      state.selected_document.term_days = contact.provider ? contact.provider.pay_days : 0;
    }

    // ventas
    if (state.selected_model.voucher_type && state.selected_model.voucher_type.document_nature && state.selected_model.voucher_type.document_nature.code_parameter === '20') {
      state.selected_document.term_days = contact.pay_days ? contact.pay_days : 0;
    }


  }
}

/**
 * Asigna valores a los datos de la sucursal en selected_document
 * @param state
 * @param contact_id
 */
export function setDataContactWarehouse(state, contact_warehouse_id) {
  let contact_warehouse = state.contacts_warehouses.find(
    cw => cw.id == contact_warehouse_id
  );

  if (!contact_warehouse) {
    contact_warehouse = {};
  } else {
    state.selected_document.warehouse_id = contact_warehouse_id;
  }

  state.selected_document.warehouse = contact_warehouse;
  state.selected_document.warehouse.address = contact_warehouse.address;
  if (state.selected_document.documents_information != null) {
    state.selected_document.documents_information.price_list =
      contact_warehouse.price_list_id;
  } else {
    state.selected_document.documents_information = {
      price_list: contact_warehouse.price_list_id
    };
  }
}

/**
 * Agrega un document_product al array de documents_products, atributo de selected_document
 * @param state
 * @param contact_id
 */
export function addDocumentProduct(state, document_product) {
  // Buscamos el producto en la grilla.
  let temp_document_product = state.selected_document.documents_products.find(
    dp => dp.id == document_product.id
  );


  // Creamos
  if (!temp_document_product) {
    if (state.selected_model.pay_taxes) {
      if (document_product.document_product_taxes && document_product.document_product_taxes.length > 0) {
        let iva = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "10"
        );

        let impo = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "12"
        );

        let iva_5 = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "101"
        );

        document_product.total_value_iva5  = iva_5 ? iva_5.value : null;
        document_product.total_value_iva    = iva   ? iva.value   : null;
        document_product.total_value_impo   = impo  ? impo.value  : null;

        let icui = document_product.document_product_taxes.find(
            dpt => dpt.tax && dpt.tax.code == "30"
        );

        document_product.total_value_icui = icui ? icui.value : null;
      }
    }
    document_product.location = extractLocationFromProduct(document_product);
    state.selected_document.documents_products.push(document_product);
  }
  // Actualizamos
  else {
    // TRM
    temp_document_product.total_value_brut_us =
      document_product.total_value_brut_us;
    temp_document_product.total_value_us = document_product.total_value_us;
    temp_document_product.discount_value_us =
      document_product.discount_value_us;

    temp_document_product.unit_value_before_taxes =
      document_product.unit_value_before_taxes;
    temp_document_product.total_value_brut = document_product.total_value_brut;
    temp_document_product.total_value = document_product.total_value;
    temp_document_product.physical_unit = document_product.physical_unit;
    temp_document_product.discount_value = document_product.discount_value;
    temp_document_product.discount_value_unit =
      document_product.discount_value_unit;
    temp_document_product.description = document_product.description;
    temp_document_product.quantity = document_product.quantity;
    temp_document_product.is_benefit = document_product.is_benefit;
    temp_document_product.product.inventory =
      document_product.product.inventory;
    temp_document_product.location = extractLocationFromProduct(document_product);
    temp_document_product.inventory_cost_value_unit =
      document_product.inventory_cost_value_unit;
    temp_document_product.inventory_cost_value =
      document_product.inventory_cost_value;

    if (state.selected_model.pay_taxes) {
      if (document_product.document_product_taxes && document_product.document_product_taxes.length > 0) {
        let iva = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "10"
        );
        let impo = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "12"
        )
        let iva_5 = document_product.document_product_taxes.find(
          dpt => dpt.tax && dpt.tax.code == "101"
        )

        temp_document_product.total_value_iva5      = iva_5 ? iva_5.value : null;
        temp_document_product.total_value_iva   = iva   ? iva.value   : null;
        temp_document_product.total_value_impo  = impo  ? impo.value  : null;

        let icui = document_product.document_product_taxes.find(
            dpt => dpt.tax && dpt.tax.code == "30"
        );

          temp_document_product.total_value_icui = icui ? icui.value : null;
      }
    }
  }

  // Agregar al bk products
  let keyBackupDocuments = state.backup_documents_products.findIndex(
    bdp => bdp.id == document_product.id
  );
  state.backup_documents_products[keyBackupDocuments] = JSON.parse(
    JSON.stringify(document_product)
  );
}

/**
 * Establece los parametros para la busqueda de productos
 * @param state
 * @param params_list_products
 */
export function setParamsListProducts(state, params_list_products) {
  state.params_list_products = params_list_products;
}

/**
 * Asigna un valor a la variable de state show_promotions_modal
 * @param state
 * @param show_promotions_modal
 */
export function setShowPromotionsModal(state, show_promotions_modal) {
  state.show_promotions_modal = show_promotions_modal;
}

/**
 * Asigna un valor a la variable de state promotions
 * @param state
 * @param promotions
 */
export function setPromotions(state, promotions) {
  promotions.map(pr => {
    if (!pr.hasOwnProperty("disable_button")) {
      pr.disable_button = true;
    }
  });

  state.promotions = promotions;
}

/**
 * Asignar productos filtrados por criterios de clasificación
 * @param state
 * @param products_filtered
 */
export function setProductsFiltered(state, products_filtered) {
  state.products_filtered = products_filtered;
}

export function setDocProductDefaultBranchofficeWarehouseId(
  state,
  branchoffice_warehouse_id = null
) {
  if (branchoffice_warehouse_id) {
    state.doc_product_default_branchoffice_warehouse_id = parseInt(
      branchoffice_warehouse_id
    );
  } else {
    state.doc_product_default_branchoffice_warehouse_id = parseInt(
      localStorage.selected_branchoffice_warehouse
    );
  }
}

export function setAccounts(state, accounts){
  state.accounts = accounts
}

export function setAccountsRteFte(state, accounts_rete_fte){
  state.accounts_rete_fte = accounts_rete_fte
}

export function setAccountsRteIca(state, accounts_rete_ica){
  state.accounts_rete_ica = accounts_rete_ica
}

export function setCenterCosts(state, center_costs){
  state.center_costs = center_costs
}

// Set column
export function setColumnTable(state) {

    let show_icui_column = false;
    let show_sugary_drinks = false

    state.selected_document.documents_products.forEach(dp => {
        show_icui_column = show_icui_column ? show_icui_column : dp.document_product_taxes.some(dpt => dpt.tax && dpt.tax.code === '30');
        show_sugary_drinks = show_sugary_drinks ? show_sugary_drinks : dp.document_product_taxes.some(dpt => dpt.tax && dpt.tax.code === '40');
    });

    let base_doc_title = 'Orden';
    let document_nature = state.selected_model.voucher_type && state.selected_model.voucher_type.document_nature ? state.selected_model.voucher_type.document_nature.code_parameter : '';
    if (['10', '11'].includes(document_nature)) base_doc_title = 'Orden Comp';
    if (['12', '22'].includes(document_nature)) base_doc_title = 'Factura';
    let subscriber = JSON.parse(localStorage.getItem('subscriber'));
    let is_colsaisa = subscriber && subscriber.identification === '900338016';
    state.columnsTable = [
        {name: 'Codigo', field: 'product.code', width: 150},
        {
            name: base_doc_title,
            field: 'base_doc',
            visible: state.selected_model.doc_base_management && !is_colsaisa
        },
        {
            name: 'Descrip',
            field: 'description',
            format: 'text',
            width: 400,
            style: {width: '400px', 'max-width': '400px'},
            editable: !state.loading_request.dp && state.action != 'view'
        },
        {
            name: 'Cuenta Contable',
            field: 'account_id',
            visible: state.selected_model.capture_accounting_account
        },
        {
            name: 'Bodega',
            field: 'branchoffice_warehouse_id',
            visible: state.selected_model.branchoffice_change !== null
        },
        {
            name: [4,5].includes(state.selected_model.stock_control) ? 'Dispon' : 'Exist',
            field: 'existence',
            width: 140,
            format: 'number',
            visible: state.action != 'view'
        },
        {
            name: 'Ubicación',
            key: 'location',
            field: 'location',
            visible: state.selected_model.see_location,
            format: 'text',
            editable: state.selected_model.edit_location,
            width: 200
        },
        {
            name: 'Vr-Unit-Base',
            field: 'base_unit_value',
            visible:
                state.selected_model.see_vrunit_base &&
                !state.selected_model.hide_values,
            width: 140,
            format: 'currency',
            editable: !state.loading_request.dp &&
                state.selected_model.purchase_difference_management &&
                state.action != 'view'
        },
        {
            name: 'Cant Ord',
            field: 'original_quantity',
            width: 140,
            format: 'number',
            visible: state.selected_model.doc_base_management != 2
        },
        {
            name: 'Cant BackO',
            field: 'backorder_quantity',
            visible: state.selected_model.see_cant_backorder && state.selected_model.back_order_control == 1,
            width: 140,
            format: 'number'
        },
        {
            name: 'Cant BO 2',
            field: 'backorder_quantity_2',
            visible: state.selected_model.see_cant_backorder && state.selected_model.back_order_control == 2,
            width: 140,
            format: 'number'
        },
        {
            name: 'Cantidad',
            field: 'quantity',
            editable: !state.loading_request.dp &&
                state.action != 'view' &&
                state.selected_document.in_progress &&
                !state.selected_model.credit_note,
            format: 'number'
        },
        {
            name: 'Empleado',
            field: 'seller_id',
            visible: state.selected_model.seller_technician_per_product !== null
        },
        {
            name: 'Vr Brut Orig',
            field: 'total_value_brut_orig',
            width: 140,
            visible: state.selected_model.credit_note
        },
        {
            name: 'Cant Fisica',
            field: 'physical_unit',
            visible: state.selected_model.see_physical_cant,
            format: 'number',
            editable: !state.loading_request.dp &&
                state.selected_model.edit_physical_cant &&
                state.selected_document.in_progress,
            width: 140
        },
        {
            name: 'Lote',
            field: 'lot',
            visible: false,
            editable: !state.loading_request.dp && false
        },
        {
            name: 'Vr Unit',
            field: 'unit_value_before_taxes',
            editable: !state.loading_request.dp &&
                state.selected_model.edit_unit_value &&
                state.selected_document.in_progress &&
                state.action != 'view',
            format: 'currency',
            width: 140,
            visible:
                !state.selected_model.hide_values && !state.selected_model.credit_note
        },
        {
            name: 'Promo Aplic',
            field: 'applied_promotion',
            visible: state.selected_model.see_applied_promotion
        },
        {
            name: 'Vr Dcto Unit',
            field: 'discount_value_unit',
            visible:
                state.action != 'view' &&
                state.selected_model.see_discount &&
                (!state.selected_model.TRM_value ||
                    state.selected_model.TRM_value == 2),
            editable: !state.loading_request.dp &&
                state.selected_model.edit_discount &&
                state.selected_document.in_progress,
            format: 'currency'
        },
        {
            name: 'Vr Dcto',
            field: 'discount_value',
            visible:
                state.selected_model.see_discount &&
                (!state.selected_model.TRM_value ||
                    state.selected_model.TRM_value == 2),
            editable: !state.loading_request.dp && false,
            format: 'currency'
        },
        {
            name: 'Vr Dcto Unit',
            field: 'discount_value_unit_us',
            format: 'currency',
            type_currency: 'USD',
            visible:
                state.selected_model.see_discount &&
                state.selected_model.TRM_value &&
                state.selected_model.TRM_value != 2,
            editable: !state.loading_request.dp &&
                state.selected_model.edit_discount &&
                state.selected_document.in_progress
        },
        {
            name: 'Vr Dcto',
            field: 'discount_value_us',
            format: 'currency',
            type_currency: 'USD',
            visible:
                state.selected_model.see_discount &&
                state.selected_model.TRM_value &&
                state.selected_model.TRM_value != 2,
            editable: !state.loading_request.dp && false
        },
        {
            name: 'Vr Bruto',
            field: 'total_value_brut',
            width: 140,
            format: 'currency',
            editable: !state.loading_request.dp && state.selected_model.credit_note && state.action != 'view',
            visible:
                !state.selected_model.hide_values &&
                (!state.selected_model.TRM_value || state.selected_model.TRM_value == 2)
        },
        {
            name: 'Vr Bruto',
            field: 'total_value_brut_us',
            width: 140,
            format: 'currency',
            type_currency: 'USD',
            editable: !state.loading_request.dp && state.selected_model.credit_note && state.action != 'view',
            visible:
                !state.selected_model.hide_values &&
                state.selected_model.TRM_value &&
                state.selected_model.TRM_value != 2
        },
        {
            name: 'Vr IVA',
            field: 'total_value_iva',
            width: 140,
            visible: !state.selected_model.hide_values && state.selected_model.pay_taxes,
            editable: !state.loading_request.dp && state.selected_model.edit_value_iva && state.action != 'view',
            format: 'currency'
        },
        {
          name: 'Vr IVA 5%',
          field: 'total_value_iva5',
          width: 140,
          visible: !state.selected_model.hide_values && state.selected_model.pay_taxes && !is_colsaisa,
          editable: !state.loading_request.dp && state.selected_model.edit_value_iva && state.action != 'view',
          format: 'currency'
        },
        {
            name: 'Vr ICUI',
            field: 'total_value_icui',
            width: 140,
            visible: show_icui_column,
            editable: !state.loading_request.dp && false,
            format: 'currency'
        },
        {
          name: 'Imp-Azuc',
          field: 'total_value_sugary_drinks',
          width: 140,
          visible: show_sugary_drinks,
          format: 'currency'
      },
        {
            name: 'Vr-Imponsumo',
            field: 'total_value_impo',
            width: 140,
            visible: !state.selected_model.hide_values && state.selected_model.pay_taxes && state.selected_model.manage_nonconsumption,
            editable: !state.loading_request.dp && state.selected_model.edit_value_iva && state.action != 'view',
            format: 'currency'
        },
        {
            name: 'Vr Total',
            field: 'total_value',
            width: 140,
            visible:
                !state.selected_model.hide_values &&
                (!state.selected_model.TRM_value || state.selected_model.TRM_value == 2)
        },
        {
            name: 'Vr Total',
            field: 'total_value_us',
            format: 'currency',
            type_currency: 'USD',
            width: 140,
            visible:
                !state.selected_model.hide_values &&
                state.selected_model.TRM_value &&
                state.selected_model.TRM_value != 2
        },
        {
            name: '% Arancel',
            field: 'tariff_percentage',
            width: 140,
            visible: state.selected_model.edit_tariff,
            editable: !state.loading_request.dp && state.action != 'view',
            format: 'currency'
        },
        {
            name: 'Costo Unit',
            field: 'inventory_cost_value_unit',
            width: 140,
            visible: state.selected_model.edit_cost,
            editable: !state.loading_request.dp && state.selected_model.edit_cost && state.action != 'view',
            format: 'currency'
        },
        {
            name: 'Costo Total',
            field: 'inventory_cost_value',
            width: 140,
            visible: state.selected_model.edit_cost,
            editable: !state.loading_request.dp && false,
            format: 'currency'
        },
        /*{
          name: 'Vendedor',
          field: 'seller_id',
          visible: state.selected_model.see_seller,
          editable: !state.loading_request.dp && state.selected_model.edit_seller && state.selected_document.in_progress,
        },*/
        {
            name: 'Observaciones',
            field: 'observation',
            width: 500,
            format: 'long_text',
            visible: state.selected_model.see_product_observation,
            editable: !state.loading_request.dp &&
                state.selected_model.edit_product_observation &&
                state.selected_document.in_progress
        },
        {
            name: 'Acciones',
            field: 'actions',
            width: 150,
            visible: state.action != 'view'
        }
    ];
}

export function setTraceDocumentProduct(state, data) {
  state.report_back_order = [];

  data.map((d, index_d) => {
    var item = {
      id: d.id,
      date: d.date,
      document: d.document_vouchertype_name,
      consecutive: d.consecutive,
      quantity: d.quantity,
      backorder: d.backorder,
      backorder_value: d.backorder_value,
      operation_type: d.operationType,
      prefix: d.prefix,
      invoice_link: d.invoice_link
    };

    state.report_back_order.push(item);
  });
}

export function setUpdatedContactWarehouses(state, data) {
  let warehousesUpdated = data.data;
  let warehouses = state.selected_document.contact.warehouses;

  warehouses.map((w, iw) => {
    if (w.id == warehousesUpdated.id) {
      warehouses.splice(iw, 1);
      warehouses.push(warehousesUpdated);
    }
  });
}

export function getParamsWarehouseRetention(state) {
  let warehouse_id = state.selected_document.warehouse_id;

  // Validamos que el dato no este vacio
  if (warehouse_id === undefined || warehouse_id == "" || warehouse_id == null)
    return;

  // Traemos el warehouse selecionado
  let selected_warehouse = state.selected_document.contact.warehouses.find(
    w => w.id == warehouse_id
  );

  if (selected_warehouse) {
    state.tableRetention.map(retention => {
      retention.fields.map(field => {
        if (retention.prefix == "FUE") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_fue_prod_vr_limit;
            field.percentage = selected_warehouse.ret_fue_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_fue_serv_vr_limit;
            field.percentage = selected_warehouse.ret_fue_serv_percentage;
          }
        }

        if (retention.prefix == "IVA") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_iva_prod_vr_limit;
            field.percentage = selected_warehouse.ret_iva_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_iva_serv_vr_limit;
            field.percentage = selected_warehouse.ret_iva_serv_percentage;
          }
        }

        if (retention.prefix == "ICA") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_ica_prod_vr_limit;
            field.percentage = selected_warehouse.ret_ica_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_ica_serv_vr_limit;
            field.percentage = selected_warehouse.ret_ica_serv_percentage;
          }
        }
      });
    });
  }
}

export function setParamsWarehouseRetention(state, selected_warehouse) {
  if (selected_warehouse) {
    state.tableRetention.map(retention => {
      retention.fields.map(field => {
        if (retention.prefix == "FUE") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_fue_prod_vr_limit;
            field.percentage = selected_warehouse.ret_fue_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_fue_serv_vr_limit;
            field.percentage = selected_warehouse.ret_fue_serv_percentage;
          }
        }

        if (retention.prefix == "IVA") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_iva_prod_vr_limit;
            field.percentage = selected_warehouse.ret_iva_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_iva_serv_vr_limit;
            field.percentage = selected_warehouse.ret_iva_serv_percentage;
          }
        }

        if (retention.prefix == "ICA") {
          if (field.prefix == "product") {
            field.vr_limit = selected_warehouse.ret_ica_prod_vr_limit;
            field.percentage = selected_warehouse.ret_ica_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = selected_warehouse.ret_ica_serv_vr_limit;
            field.percentage = selected_warehouse.ret_ica_serv_percentage;
          }
        }
      });
    });
  }
}

export function getParamsBaseDocumentRetention(state) {
  let baseDocument = state.selected_document.document;
  let retentions = state.tableRetention;

  if (baseDocument) {
    retentions.map(retention => {
      retention.fields.map(field => {
        if (retention.prefix == "FUE") {
          if (field.prefix == "product") {
            field.vr_limit = baseDocument.ret_fue_prod_vr_limit;
            field.percentage = baseDocument.ret_fue_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = baseDocument.ret_fue_serv_vr_limit;
            field.percentage = baseDocument.ret_fue_serv_percentage;
          }
        }

        if (retention.prefix == "IVA") {
          if (field.prefix == "product") {
            field.vr_limit = baseDocument.ret_iva_prod_vr_limit;
            field.percentage = baseDocument.ret_iva_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = baseDocument.ret_iva_serv_vr_limit;
            field.percentage = baseDocument.ret_iva_serv_percentage;
          }
        }

        if (retention.prefix == "ICA") {
          if (field.prefix == "product") {
            field.vr_limit = baseDocument.ret_ica_prod_vr_limit;
            field.percentage = baseDocument.ret_ica_prod_percentage;
          }
          if (field.prefix == "service") {
            field.vr_limit = baseDocument.ret_ica_serv_vr_limit;
            field.percentage = baseDocument.ret_ica_serv_percentage;
          }
        }
      });
    });
  }
}

export function resetReportBackOrder(state) {
  state.report_back_order = [];
}

export function setParametersTable(state, data) {
  state.parametersTable = data;
}

export function setUpdateValuesDocument(state, data) {
  const retentionBase =
    state.selected_model.retention_management == 3 ? true : false;

  const {
    document,
    getTotalIvaProducts,
    getTotalIvaServices,
    getValBrutInProducts,
    getValBrutInServices
  } = data;

  state.selected_document.total_value = document.total_value;
  state.selected_document.total_value_brut = document.total_value_brut;
  state.selected_document.taxes = document.taxes;

  // Retenciones
  state.tableRetention.map(retencion => {
    if (retencion.prefix === "IVA") {
      retencion.base_value = getTotalIvaProducts;
      retencion.base_serv_value = getTotalIvaServices;
    } else {
      retencion.base_value = getValBrutInProducts;
      retencion.base_serv_value = getValBrutInServices;
    }
  });
}

export function setUpdateDocumentValues(state, data) {
  // Totales

  state.selected_document.total_value = data.total_value;
  state.selected_document.total_value_brut = data.total_value_brut;
  state.selected_document.taxes = data.taxes;

  // Totales TRM
  state.selected_document.total_value_us = data.total_value_us;
  state.selected_document.total_value_brut_us = data.total_value_brut_us;

  // Retenciones
  // # FUE
  // productos
  state.selected_document.ret_fue_prod_vr_limit = data.ret_fue_prod_vr_limit;
  state.selected_document.ret_fue_prod_percentage = data.ret_fue_prod_percentage;
  state.selected_document.ret_fue_prod_total = data.ret_fue_prod_total;
  state.selected_document.ret_fue_base_value = data.ret_fue_base_value;

  // servicios
  state.selected_document.ret_fue_serv_vr_limit = data.ret_fue_serv_vr_limit;
  state.selected_document.ret_fue_serv_percentage = data.ret_fue_serv_percentage;
  state.selected_document.ret_fue_serv_total = data.ret_fue_serv_total;
  state.selected_document.ret_fue_serv_base_value = data.ret_fue_serv_base_value;

  // lubricantes
  state.selected_document.ret_fue_lub_vr_limit = data.ret_fue_lub_vr_limit;
  state.selected_document.ret_fue_lub_percentage = data.ret_fue_lub_percentage;
  state.selected_document.ret_fue_lub_total = data.ret_fue_lub_total;
  state.selected_document.ret_fue_lub_base_value = data.ret_fue_lub_base_value;

  // total
  state.selected_document.ret_fue_total = data.ret_fue_total;

  // # IVA
  // productos
  state.selected_document.ret_iva_prod_vr_limit = data.ret_iva_prod_vr_limit;
  state.selected_document.ret_iva_prod_percentage = data.ret_iva_prod_percentage;
  state.selected_document.ret_iva_prod_total = data.ret_iva_prod_total;
  state.selected_document.ret_iva_base_value = data.ret_iva_base_value;

  // servicios
  state.selected_document.ret_iva_serv_vr_limit = data.ret_iva_serv_vr_limit;
  state.selected_document.ret_iva_serv_percentage = data.ret_iva_serv_percentage;
  state.selected_document.ret_iva_serv_total = data.ret_iva_serv_total;
  state.selected_document.ret_iva_serv_base_value = data.ret_iva_serv_base_value;

  // total
  state.selected_document.ret_iva_total = data.ret_iva_total;

  // # ICA
  // productos
  state.selected_document.ret_ica_prod_vr_limit = data.ret_ica_prod_vr_limit;
  state.selected_document.ret_ica_prod_percentage = data.ret_ica_prod_percentage;
  state.selected_document.ret_ica_prod_total = data.ret_ica_prod_total;
  state.selected_document.ret_ica_base_value = data.ret_ica_base_value;

  // servicios
  state.selected_document.ret_ica_serv_vr_limit = data.ret_ica_serv_vr_limit;
  state.selected_document.ret_ica_serv_percentage = data.ret_ica_serv_percentage;
  state.selected_document.ret_ica_serv_total = data.ret_ica_serv_total;
  state.selected_document.ret_ica_serv_base_value = data.ret_ica_serv_base_value;

  // lubricantes
  state.selected_document.ret_ica_lub_vr_limit = data.ret_ica_lub_vr_limit;
  state.selected_document.ret_ica_lub_percentage = data.ret_ica_lub_percentage;
  state.selected_document.ret_ica_lub_total = data.ret_ica_lub_total;
  state.selected_document.ret_ica_lub_base_value = data.ret_ica_lub_base_value;

  // total
  state.selected_document.ret_ica_total = data.ret_ica_total;

  if (data.documents_products) {
      data.documents_products.map(dp => {
          let dpdoc = state.selected_document.documents_products.find(
              dpd => dpd.id === dp.id
          );

          if (dpdoc) {
              dpdoc.total_value_iva = dp.total_value_iva;
              dpdoc.total_value_brut = dp.total_value_brut;
              dpdoc.total_value = dp.total_value;
          }
      });
  }
}

export function setUpdateDocumentValuesRetention(state, data) {
  // Retenciones
  // # FUE
  // productos
  state.selected_document.ret_fue_prod_vr_limit = data.ret_fue_prod_vr_limit;
  state.selected_document.ret_fue_prod_percentage =
    data.ret_fue_prod_percentage;
  state.selected_document.ret_fue_prod_total = data.ret_fue_prod_total;
  state.selected_document.ret_fue_base_value = data.ret_fue_base_value;

  // servicios
  state.selected_document.ret_fue_serv_vr_limit = data.ret_fue_serv_vr_limit;
  state.selected_document.ret_fue_serv_percentage =
    data.ret_fue_serv_percentage;
  state.selected_document.ret_fue_serv_total = data.ret_fue_serv_total;
  state.selected_document.ret_fue_serv_base_value =
    data.ret_fue_serv_base_value;

  // lubricantes
  state.selected_document.ret_fue_lub_vr_limit = data.ret_fue_lub_vr_limit;
  state.selected_document.ret_fue_lub_percentage = data.ret_fue_lub_percentage;
  state.selected_document.ret_fue_lub_total = data.ret_fue_lub_total;
  state.selected_document.ret_fue_lub_base_value = data.ret_fue_lub_base_value;

  // total
  state.selected_document.ret_fue_total = data.ret_fue_total;

  // # IVA
  // productos
  state.selected_document.ret_iva_prod_vr_limit = data.ret_iva_prod_vr_limit;
  state.selected_document.ret_iva_prod_percentage =
    data.ret_iva_prod_percentage;
  state.selected_document.ret_iva_prod_total = data.ret_iva_prod_total;
  state.selected_document.ret_iva_base_value = data.ret_iva_base_value;

  // servicios
  state.selected_document.ret_iva_serv_vr_limit = data.ret_iva_serv_vr_limit;
  state.selected_document.ret_iva_serv_percentage =
    data.ret_iva_serv_percentage;
  state.selected_document.ret_iva_serv_total = data.ret_iva_serv_total;
  state.selected_document.ret_iva_serv_base_value =
    data.ret_iva_serv_base_value;

  // total
  state.selected_document.ret_iva_total = data.ret_iva_total;

  // # ICA
  // productos
  state.selected_document.ret_ica_prod_vr_limit = data.ret_ica_prod_vr_limit;
  state.selected_document.ret_ica_prod_percentage =
    data.ret_ica_prod_percentage;
  state.selected_document.ret_ica_prod_total = data.ret_ica_prod_total;
  state.selected_document.ret_ica_base_value = data.ret_ica_base_value;

  // servicios
  state.selected_document.ret_ica_serv_vr_limit = data.ret_ica_serv_vr_limit;
  state.selected_document.ret_ica_serv_percentage =
    data.ret_ica_serv_percentage;
  state.selected_document.ret_ica_serv_total = data.ret_ica_serv_total;
  state.selected_document.ret_ica_serv_base_value =
    data.ret_ica_serv_base_value;

  // lubricantes
  state.selected_document.ret_ica_lub_vr_limit = data.ret_ica_lub_vr_limit;
  state.selected_document.ret_ica_lub_percentage = data.ret_ica_lub_percentage;
  state.selected_document.ret_ica_lub_total = data.ret_ica_lub_total;
  state.selected_document.ret_ica_lub_base_value = data.ret_ica_lub_base_value;

  // total
  state.selected_document.ret_ica_total = data.ret_ica_total;
}

export function addDocumentProductAll(state, data) {
  state.selected_document.documents_products = data.message;
}

// Asignar valores de la cartera
export function setValuesReceivablesByContactId(state, data) {
  let total_wallet = 0;
  let credit_quota = state.selected_document.contact.customer.credit_quota;

  data.map((d, indexd) => {
    total_wallet += d.total_balance;
  });

  state.selected_document.contact.customer.total_wallet = total_wallet;
  state.selected_document.contact.customer.credit_quota_available = 0;

  if (total_wallet >= credit_quota) {
    state.selected_document.contact.customer.credit_quota_available = 0;
  } else {
    state.selected_document.contact.customer.credit_quota_available =
      credit_quota - total_wallet;
  }
}

export function deleteItemDocumentsProducts(state, document_product_id) {
  let key_document_product = state.selected_document.documents_products.findIndex(
    dp => dp.id == document_product_id
  );
  if (key_document_product != -1) {
    state.selected_document.documents_products.splice(key_document_product, 1);
  }
}

export function deleteItemsDocumentsProducts(state, documents_products_ids) {
    documents_products_ids.map(dpi => {
        let key_document_product = state.selected_document.documents_products.findIndex(
            dp => dp.id === dpi
        );

        if (key_document_product !== -1) {
            state.selected_document.documents_products.splice(key_document_product, 1);
        }
    })
}

export function setMails(state, mails) {
  state.mails = mails;
}

export function setSellerIdByContactWarehouse(state, seller) {
  state.selected_document.seller_id = seller.id;
}
export function resetSellerId(state) {
  state.selected_document.seller_id = null;
}
export function setUpdating(state, data) {
  state.updating = data;
}

export function setNamePdf(state, name_pdf) {
  state.name_pdf = name_pdf;
}

export function setBranchofficeWarehouses(state, data) {
  state.branchofficeWarehouses = data;
}
export function setEditRetention(state, data) {
  state.edit_retention = data;
}
export function setEditBaseRetention(state, data) {
  state.edit_base_retention = data;
}

export function setContactsWarehouseById(state, data) {
  state.selected_contact_warehouse = data;
}

export function resetContacts(state, data) {
  state.contacts = [];
}

export function setEditRetentionDocument(state, value) {
  state.selected_document.edit_retention = value;
}
export function setFinalizingDocument(state, value) {
  state.finalizing_document = value;
}
export function setDocumentFile(state, data) {
  let extension = data.name.split(".");
  let file = {
    id: null,
    name: data.name,
    extension: extension[extension.length - 1],
    path: "",
    size: data.size,
    sent: false,
    document_id: state.selected_document.id
  };

  state.selected_document.files.push(file);

  state.document_files_new.push(data);
}
export function deleteDocumentFile(state, data) {
  if (data.id) {
    let key_file = state.selected_document.files.findIndex(
      f => f.id === data.id
    );
    state.selected_document.files.splice(key_file, 1);
    state.document_files_delete.push(data);
  } else {
    let key_file = state.selected_document.files.findIndex(
      f => f.size === data.size && f.name === data.name
    );
    state.selected_document.files.splice(key_file, 1);

    let key_file_new = state.document_files_new.findIndex(
      f => f.size === data.size && f.name === data.name
    );
    state.document_files_new.splice(key_file_new, 1);
  }
}

export function resetDataDocumentFIles(state) {
  state.document_files_new = [];
  state.document_files_delete = [];
}

export function resetRetentionStates(state) {
  state.edit_base_retention = false;
  state.edit_retention = false;
}

export function setDocumentProductsEditIva(state, document_product) {
  state.document_products_edit_iva.push({
    id: document_product.id
  });
}
export function removeDocumentProductsEditIva(state, document_product_id) {
  let key_document_product = state.document_products_edit_iva.findIndex(
    dp => dp.id == document_product_id
  );
  if (key_document_product != -1) {
    state.document_products_edit_iva.splice(key_document_product, 1);
  }
}
export function setAuthorizeDocuments(state, value) {
  state.authorize_documents = value;
}
export function resetAuthorizeDocuments(state) {
  state.authorize_documents = false;
}

// MODAL CREAR TERCERO
export function setCities(state, cities) {
  state.cities = cities;
}

export function setDepartments(state, departments) {
  state.departments = departments;
}

export function setIdentificationTypes(state, identificationTypes) {
  state.identificationTypes = identificationTypes;
}

export function setTypeNewContact(state, type) {
  let model = state.selected_model;

  if (model) {
    switch (model.contact_type) {
      case 1:
        state.newContact.is_customer = true;
        break;
      case 2:
        state.newContact.is_provider = true;
        break;
      case 3:
        state.newContact.is_employee = true;
        break;
    }
  }
}

export function setNewContact(state, newContact) {
  newContact.vehicle = defaultNewVehicle();
  newContact.department_id = newContact.city.department_id;
  state.newContact = newContact;
}

export function resetNewContact(state, preserveIdentification = false) {
  let identification;
  let identification_type;

  let city_id = state.newContact.city_id;
  let department_id = state.newContact.department_id;

  if (preserveIdentification) {
    identification = state.newContact.identification;
    identification_type = state.newContact.identification_type;
  }

  state.newContact = defaultNewContact();

  if (preserveIdentification) {
    state.newContact.identification = identification;
    state.newContact.identification_type = identification_type;
  }

  state.newContact.city_id = city_id;
  state.newContact.department_id = department_id;
}

export function setVehicles(state, vehicles) {
  state.vehicles = vehicles;
}

export function setNewContactVehicle(state, vehicle) {
  state.newContact.vehicle = vehicle;
}

export function setDataVehicle(state, vehicle_id) {
  let vehicle = state.vehicles.find(v => v.id === vehicle_id);

  if (vehicle) {
    state.dataVehicle = [
      { title: "Marca", value: vehicle.brand_vehicle.name_parameter },
      { title: "Tipo", value: vehicle.class_vehicle.name_parameter },
      {
        title: "Servicio",
        value: vehicle.servicio === 2 ? "Privado" : "Público"
      },
      { title: "Potencia", value: vehicle.power },
      { title: "Cilindraje", value: vehicle.cylinder_capacity },
      { title: "Peso", value: vehicle.weight },
      { title: "Tipo de caja", value: vehicle.box_type },
      { title: "Puertas", value: vehicle.doors },
      { title: "Combustible", value: vehicle.fuel },
      { title: "Nacionalidad", value: vehicle.nationality },
      { title: "Capacidad de pasajeros", value: vehicle.passenger_capacity },
      { title: "Transmisión", value: vehicle.transmission },
      { title: "Tipo de caja", value: vehicle.box_type }
    ];
  } else {
    state.dataVehicle = [];
  }
}

export function setPersonClasses(state, personClasses) {
  state.personClasses = personClasses;
}

export function setTaxpayerTypes(state, taxpayerTypes) {
  state.taxpayerTypes = taxpayerTypes;
}

export function setTaxRegimes(state, taxRegimes) {
  state.taxRegimes = taxRegimes;
}

export function setFiscalResponsibilitys(state, fiscalResponsibilitys) {
  state.fiscalResponsibilitys = fiscalResponsibilitys;
}

export function setPayments(state, payments) {
  state.payments = payments;
}

export function setCategoriesCustomers(state, categoriesCustomers) {
  state.categoriesCustomers = categoriesCustomers;
}

export function setModalNewContactStep(state, step) {
  state.modalNewContact.step = step;
}

export function setModalNewContact(state, modalNewContact) {
  state.modalNewContact.show = modalNewContact;
}

export function resetNewContactVehicle(state, preserveLicencePlate = false) {
  let licence_plate;

  if (preserveLicencePlate) {
    licence_plate = state.newContact.vehicle.id;
  }

  state.newContact.vehicle = defaultNewVehicle();

  if (preserveLicencePlate) {
    state.newContact.vehicle.id = licence_plate;
    state.newContact.vehicle.license_plate = licence_plate;
  }
}

export function setAddressNewContact(state, address) {
  if (address) {
    state.newContact.address = address;
  }
}

//--- METODOS DE PAGO

export function setPaymentMethods(state, data) {
  state.modalPaymentMethods.paymentMethods = data;
}



//
//
export function setDocumentsThreadHistory(state, documents) {
  state.modalDocumentThreadHistory.documents = documents;
}

export function setDocumentsThreadHistoryShowModal(state, value) {
  state.modalDocumentThreadHistory.showModal = value;
}

export function resetDocumentsThreadHistorys(state) {
  state.modalDocumentThreadHistory.documents = [];
}

export function setSaveDocument(state, value) {
  state.saveDocument = value;
}

export function setAdditionalDocuments(state, additional_documents){
  state.additional_documents = additional_documents
}

export function setConveyors(state, conveyors){
  state.conveyors = conveyors
}

export function setProjects(state, projects){
  state.projects = projects
}

export function setMoney(state, Moneys) {
  state.moneys = Moneys;
}
export function setModalPaymentMethods(state, modalPaymentMethods) {
    state.selected_document.payment_methods = modalPaymentMethods;
}


export function setTableSearchGlobalParams(state,params) {
    state.TableSearchGlobal.params.branchoffice_id = params.branchoffice_id;
    state.TableSearchGlobal.params.vouchertype_id = params.vouchertype_id;
    state.TableSearchGlobal.params.model_id = params.model_id;
    state.TableSearchGlobal.params.contact_id = params.contact_id;
    state.TableSearchGlobal.params.warehouse_id = params.warehouse_id;
    state.contacts_lite = params.contacts;
    state.contacts = params.contacts;

}
/**
 * Establecer un valor para la variable back_order.
 */
export function setBackOrder(state, back_order) {

    let sum_back_order = {
	    variant: null,
        total_unds: 0,
        total_backorder_quantity: 0
    };

    back_order.map(bo => {
        sum_back_order.total_unds += bo.total_unds;
        sum_back_order.total_backorder_quantity += bo.total_backorder_quantity;
    })

    if (!back_order.length){
	    sum_back_order.variant = null;
    }else if (sum_back_order.total_unds < sum_back_order.total_backorder_quantity){
        sum_back_order.variant = 'warning';
    }else if (sum_back_order.total_unds === sum_back_order.total_backorder_quantity){
        sum_back_order.variant = 'success';
    } else if (sum_back_order.total_unds === 0){
        sum_back_order.variant = 'danger';
    }

    state.back_order = sum_back_order;
}
export function setDataReportExistProduct(state, data) {
    state.data_report_exist_products = data
}

export function setErrorsPercentageDiscount(state, errors) {
    state.errors_percentage_discount = errors;
}

export function setDocumentVehicleInspection(state, parameters) {
  let document_vehicle_inspection = [];

  parameters.map(i => {
    let item = {
      parameter_id: i.id,
      parameter: {
        id: i.id,
        name_parameter: i.name_parameter,
        alphanum_data_second: i.alphanum_data_second
      },
      observation: '',
      value: null,
      millimeter: null
    };
    document_vehicle_inspection.push(item);
  });

  state.document_vehicle_inspection = document_vehicle_inspection;
}

export function setModalInspection(state, modalInspection) {
  state.modalInspection.show = modalInspection;
}

export function setFilePhotoMileage(state, file_photo_mileage) {
  state.document_vehicle.file_photo_mileage = file_photo_mileage;
}

export function setFilePhotoPreviousMileage(
  state,
  file_photo_previous_mileage
) {
  state.document_vehicle.file_photo_previous_mileage = file_photo_previous_mileage;
}

export function setPhotoInspection(
  state,
  file_photo_inspection
) {
  state.document_vehicle.file_photo_inspection = file_photo_inspection;
}

export function setVideoInspection(
  state,
  file_video_inspection
) {
  state.document_vehicle.file_video_inspection =  file_video_inspection;
}

export function resetPhotoMileage(state) {
  // state.document_vehicle.photo_mileage = null;
  state.document_vehicle.file_photo_mileage = null;
}

export function resetPhotoInspection(state) {
  // state.document_vehicle.photo_inspection = null;
  // state.document_vehicle.file_photo_inspection = null;
}

export function resetVideoInspection(state) {
  // state.document_vehicle.video_inspection = null;
  // state.document_vehicle.file_video_inspection = null;
}

export function resetPhotoPreviousMileage(state) {
  // state.document_vehicle.photo_previous_mileage = null;
  state.document_vehicle.file_photo_previous_mileage = null;
}

export function setSearchDocument(state, data) {
  state.documentsList = data;
}

export function setClearDocumentVehicleInspection (state) {
    state.document_vehicle_inspection = state.document_vehicle_inspection.map(r => ({
        ...r,
        value: null,
        millimeter: null,
        observation: ''
    }));
}

export function setClearDocumentVehicle (state) {
    state.document_vehicle = {
        mileage: null,
        photo_mileage: null,
        file_photo_mileage: null,
        photo_previous_mileage: null,
        file_photo_previous_mileage: null,
        previous_mileage: null,
        previous_date_mileage: null,
        next_mileage: null,
        next_date_mileage: null,
        expiration_date_soat: null
    }
}

export function setSellersForProduct(state, data) {
    state.sellersForProduct = data;
}

export function setDocumentsFinderState(state, payload) {
  state.documentsFinderState = payload;
}

export function setEntryExitReport(state, payload) {
  state.entryExitReport = payload;
}


// WEBPACK FOOTER //
// ./src/modules/inventory-movements/mutations.js